import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const PWA_CONFIG = {
  admin: { label: "Kelas Admin", manifest: "/manifest-admin.json", theme: "#0F172A", apple: "/apple-touch-admin.png", icon: "/icon-admin-192.png" },
  guru: { label: "Kelas Guru", manifest: "/manifest-guru.json", theme: "#0D9488", apple: "/apple-touch-guru.png", icon: "/icon-guru-192.png" },
  murid: { label: "Kelas Murid", manifest: "/manifest-murid.json", theme: "#F59E0B", apple: "/apple-touch-murid.png", icon: "/icon-murid-192.png" },
  default: { label: "DUNIA KELAS", manifest: "/manifest.json", theme: "#0D9488", apple: "/apple-touch-icon.png", icon: "/icon-192.png" },
};

export function pwaRoleForPath(path) {
  const p = path || "";
  if (p.startsWith("/admin")) return "admin";
  if (p.startsWith("/guru")) return "guru";
  if (p.startsWith("/murid")) return "murid";
  return "default";
}

// Swaps the active manifest, theme-color and apple-touch-icon per role/route
// so each role installs as its own separate PWA ("ada sekatnya").
export function ManifestManager() {
  const { pathname } = useLocation();
  useEffect(() => {
    const c = PWA_CONFIG[pwaRoleForPath(pathname)];
    const set = (sel, attr, val) => { const el = document.querySelector(sel); if (el) el.setAttribute(attr, val); };
    set('link[rel="manifest"]', "href", c.manifest);
    set('meta[name="theme-color"]', "content", c.theme);
    set('link[rel="apple-touch-icon"]', "href", c.apple);
  }, [pathname]);
  return null;
}
